var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25243 7.41543C6.8343 7.41543 6.41743 7.27731 6.06868 7.00106L3.26555 4.74106C3.06368 4.57856 3.03243 4.28293 3.1943 4.08168C3.35743 3.88106 3.65243 3.84918 3.85368 4.01106L6.6543 6.26856C7.00618 6.54731 7.5018 6.54731 7.85618 6.26606L10.6287 4.01231C10.8299 3.84793 11.1249 3.87918 11.2887 4.08043C11.4518 4.28106 11.4212 4.57606 11.2206 4.73981L8.44305 6.99731C8.0918 7.27606 7.6718 7.41543 7.25243 7.41543Z",
    fill: "#06262D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1831_26038",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.516602 0.25H13.954V12.4375H0.516602V0.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1831_26038)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16598 11.5H10.3035C10.3047 11.4987 10.3097 11.5 10.3135 11.5C11.0266 11.5 11.6591 11.245 12.1441 10.7606C12.7072 10.2 13.0166 9.39437 13.0166 8.4925V4.2C13.0166 2.45438 11.8754 1.1875 10.3035 1.1875H4.16723C2.59535 1.1875 1.4541 2.45438 1.4541 4.2V8.4925C1.4541 9.39437 1.7641 10.2 2.3266 10.7606C2.8116 11.245 3.44473 11.5 4.15723 11.5H4.16598ZM4.15535 12.4375C3.19098 12.4375 2.32973 12.0875 1.66473 11.425C0.924102 10.6862 0.516602 9.645 0.516602 8.4925V4.2C0.516602 1.94813 2.08598 0.25 4.16723 0.25H10.3035C12.3847 0.25 13.9541 1.94813 13.9541 4.2V8.4925C13.9541 9.645 13.5466 10.6862 12.806 11.425C12.1416 12.0869 11.2797 12.4375 10.3135 12.4375H10.3035H4.16723H4.15535Z",
    fill: "#06262D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.8a86c8e0c6456193592b37e5a919be28.svg";
export { ForwardRef as ReactComponent };